import React from "react"
import qs from "qs"
import BIModel from "../BIModel"
import ChapterList from "../ChapterList"
import Favorite, { FavoriteButton } from "../FavoriteButton"
import ShareModel from "../ShareModel"
import MyFavoritesModal from "./MyfavoriteModal"

import "./researchCanvas.scss"
import DownloadWhitePaper from "./DownloadWhitePaper"

const getRouteFromDataset = (dataset) => {
  switch (dataset.toLowerCase()) {
    case "tsis":
      return "research"
    case "ets":
      return "ets"
    case "admin":
      return "admin-bi"
  }
}

class ResearchCanvas extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      tutorial: false,
      reportPage: null,
      fullscreen: false,
      selectedData: {},
      itemName: null,
      report: null,
      bookmarkApplied: false,
    }
  }

  static getDerivedStateFromProps = (props, state) => {
    let query = qs.parse(props.location.search, { ignoreQueryPrefix: true })
    return {
      ...state,
      tutorial: query.tutorial === "true",
      fullscreen: query.fullscreen === "true",
      itemName: query.itemName,
      reportPage: query.page,
    }
  }

  componentDidMount = () => {
    let { book, chapter } = this.props
    this.props.trackPage("Research", {
      book: book.displayName,
      chapter: chapter.displayName,
      dataset: book.dataset,
    })
  }

  getBookmark = () => {
    let searchParams = new URLSearchParams(this.props.location.search)
    return searchParams.get("bookmark")
  }

  onReportRendered = (report) => {
    const bookmark = this.getBookmark()
    if (bookmark && !this.state.bookmarkApplied) {
      this.setState({ bookmarkApplied: true }, () => {
        report.bookmarksManager.applyState(bookmark)
      })
    }
    this.setState({ report })
  }

  fullscreenToggle = () => {
    let { location, history } = this.props
    let query = qs.parse(location.search, { ignoreQueryPrefix: true })
    history.replace({
      ...location,
      search: qs.stringify(
        {
          page: this.state.reportPage,
          tutorial: this.state.tutorial,
          fullscreen: query.fullscreen === "true" ? "false" : "true",
        },
        { addQueryPrefix: true }
      ),
    })
  }

  tutorialToggle = () => {
    let query = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    })
    this.setState((prevState) => {
      this.props.history.replace({
        ...this.props.location,
        search: qs.stringify(
          {
            ...query,
            page: prevState.reportPage,
            tutorial: !prevState.tutorial,
          },
          { addQueryPrefix: true }
        ),
      })
      return {
        tutorial: !prevState.tutorial,
      }
    })
  }

  handlePrintClick = () => {
    window.print()
  }

  onAddFavorite = () => {
    let query = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    })
    this.props.trackEvent("Added Favorite", {
      type: "BI Model",
      metadata: {
        book: this.props.book.displayName,
        chapter: this.props.chapter.displayName,
        page: query.page,
        tutorial: query.tutorial === "true",
      },
    })
  }

  addPageQueryParam = (page) => {
    let query = qs.parse(location.search, { ignoreQueryPrefix: true })
    if (query.bookmark && this.state.bookmarkApplied) {
      delete query.bookmark
    }

    const isTutorial = this.state.tutorial === "true"

    this.props.history.replace({
      ...this.props.location,
      search: qs.stringify(
        {
          ...query,
          page: page,
          tutorial: isTutorial,
        },
        { addQueryPrefix: true }
      ),
    })
  }

  onDataSelected = (event) => {
    let { dataPoints, visual } = event.detail

    this.setState(({ selectedData, tutorial }) => {
      if (
        !tutorial &&
        dataPoints &&
        dataPoints.length &&
        (!selectedData[visual.name] ||
          selectedData[visual.name].length <= dataPoints.length)
      ) {
        let point = dataPoints[dataPoints.length - 1].identity[0]

        this.props.trackEvent("Selected data", {
          book: this.props.book.displayName,
          chapter: this.props.chapter.displayName,
          page: event.detail.page.displayName,
          dataTable: point.target.table,
          dataColumn: point.target.column,
          dataValue: point.equals,
          dataVisual: visual.title || visual.name,
        })

        return {
          selectedData: {
            ...selectedData,
            [visual.name]: dataPoints,
          },
        }
      }
      return null
    })
  }

  onClickShare = async () => {
    let bookmark = await this.state.report.bookmarksManager.capture()
    let url = new URL(window.location.href)
    url.searchParams.set("bookmark", bookmark.state)
    this.setState({
      slug: url.pathname + url.search,
    })
  }

  render = () => {
    let { reportPage, itemName } = this.state
    let { book, chapter, location, viewer } = this.props

    let query = qs.parse(location.search, { ignoreQueryPrefix: true })

    let datasetRoute = getRouteFromDataset(book.dataset)

    let chapters = book.chapters.map(
      ({ displayName, path, pages, whitePaperUrl }) => ({
        name: displayName,
        to: {
          pathname: `/${datasetRoute}/${book.path}/${path}`,
          search: qs.stringify(
            { fullscreen: query.fullscreen },
            { addQueryPrefix: true }
          ),
        },
        path: `/${datasetRoute}/${book.path}/${path}`,
        pages,
        whitePaperUrl,
      })
    )

    let selectedChapter = {
      name: chapter.displayName,
      path: `/${datasetRoute}/${book.path}/${chapter.path}`,
      whitePaperUrl: chapter.whitePaperUrl,
      reportPage,
    }

    return (
      <div className="research-container">
        <div className="research-header">
          <ChapterList
            chapters={chapters}
            selectedChapter={selectedChapter}
            selectedPage={this.state.reportPage}
            isTutorial={
              !!this.props.chapter.tutorialReportId && this.state.tutorial
            }
            selectedItem={itemName}
          />
          <div className="report-action-buttons">
            {query.page && this.state.report && (
              <ShareModel
                slug={this.state.slug}
                onClick={this.onClickShare}
                modelName={`${book.displayName} - ${chapter.displayName} / ${query.page}`}
              />
            )}
            {query.page && this.state.report && (
              <Favorite
                location={this.props.location}
                onAddFavorite={this.onAddFavorite}
                bookmark={this.state.report.bookmarksManager}
                dataset={this.props.book.dataset}
                favoriteType="MODEL"
                modelName={`${book.displayName} - ${chapter.displayName} / ${query.page}`}
                report={this.state.report}
                variables={{
                  favoriteType: "REPORT", //update to correct type when working on this
                }}
                trackingLocation={book.dataset + " / BI Model"}
              >
                <FavoriteButton iconBeforeText={true} />
              </Favorite>
            )}
            {selectedChapter.whitePaperUrl ? (
              <DownloadWhitePaper
                path={selectedChapter.whitePaperUrl}
                trackingLocation={book.dataset + " / BI Model"}
              />
            ) : null}
            <MyFavoritesModal trackingLocation={book.dataset + " / BI Model"} />
            <div
              className="fullscreen-toggle"
              id="fullscreen-toggle"
              onClick={this.fullscreenToggle}
            >
              {query.fullscreen === "true" ? (
                <>
                  <span className="glyphicon glyphicon-remove" />
                  <span>Minimize</span>
                </>
              ) : (
                <>
                  <span className="glyphicon glyphicon-resize-vertical" />
                  <span>Fullscreen</span>
                </>
              )}
            </div>
          </div>
        </div>
        <BIModel
          book={this.props.book.path}
          dataset={this.props.book.dataset}
          chapter={this.props.chapter.path}
          isTutorial={
            !!this.props.chapter.tutorialReportId && this.state.tutorial
          }
          onDataSelected={this.onDataSelected}
          page={reportPage}
          location={this.props.location}
          onReportRendered={this.onReportRendered}
          addPageQueryParam={this.addPageQueryParam}
          trackEvent={this.props.trackEvent}
          isExcludeRespondentsView={viewer.excludeRespondents}
        />
      </div>
    )
  }
}

export default ResearchCanvas
